/* PeakView extras: loads right after peakview-loader.js.
   - Adds the brand-trust image as the 5th gallery slide ("Our brand").
   - Keeps Shopify's real cart in step with the site's bag, so ad pixels see add-to-cart events
     and anything added in the chat assistant can be checked out.
   - Shows a checkout pill when the Shopify cart has items the site's bag doesn't show (e.g. added in chat). */
const PV = window.PV || (window.PV = {});
if (PV.gallery) PV.gallery = PV.gallery.slice(0, 4).concat(["https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20261001_173913_ff48d55f-b3b6-420f-a17a-6afc1a0293bf.png?width=1400"]);

const JSONH = { "Content-Type": "application/json", Accept: "application/json" };
const getCart = async () => (await fetch("/cart.js", { headers: { Accept: "application/json" } })).json();
const post = async (url, body) => {
  const r = await fetch(url, { method: "POST", headers: JSONH, body: JSON.stringify(body) });
  if (!r.ok) throw new Error(url + " " + r.status);
  return r.json();
};
const qtyOf = (cart, id) => cart.items.filter((x) => x.variant_id === Number(id)).reduce((t, x) => t + x.quantity, 0);
const goggleIds = () => Object.values(PV.variants || {});
const addonVariant = (id) => { const a = (PV.addons || []).find((x) => x.id === id); return a && a.variant; };
// Cart calls run one at a time so quick clicks can't race each other.
let queue = Promise.resolve();
const serial = (fn) => (queue = queue.then(fn).catch((e) => console.warn("[PeakView] cart sync", e)).then(() => PV.refreshPill && PV.refreshPill()));

// Site bag -> Shopify cart. Adds use /cart/add.js, which is what Shopify reports to ad pixels as an add to cart.
PV.addBundle = (pairs) => serial(async () => {
  const v = (PV.variants || {})[String(pairs)];
  if (!v) return;
  let cart = await getCart();
  const updates = {};
  goggleIds().forEach((x) => { if (x !== v && qtyOf(cart, x)) updates[x] = 0; });
  if (qtyOf(cart, v) > 1) updates[v] = 1;
  if (Object.keys(updates).length) cart = await post("/cart/update.js", { updates });
  if (!qtyOf(cart, v)) await post("/cart/add.js", { items: [{ id: v, quantity: 1 }] });
});
PV.toggleAddon = (id, on) => serial(async () => {
  const v = addonVariant(id);
  if (!v) return;
  const cart = await getCart();
  if (on && !qtyOf(cart, v)) await post("/cart/add.js", { items: [{ id: v, quantity: 1 }] });
  if (!on && qtyOf(cart, v)) await post("/cart/update.js", { updates: { [v]: 0 } });
});
PV.clearSiteCart = () => serial(async () => {
  const updates = {};
  goggleIds().forEach((x) => { updates[x] = 0; });
  (PV.addons || []).forEach((a) => { updates[a.variant] = 0; });
  await post("/cart/update.js", { updates });
});

// Checkout from the site's bag: the cart matches exactly what the bag shows (bundle + ticked add-ons), then go to checkout.
PV.checkout = async (qty, ids) => {
  const v = (PV.variants || {})[String(qty)];
  if (!v) return;
  const items = [v + ":1"];
  const updates = {};
  goggleIds().forEach((x) => { updates[x] = x === v ? 1 : 0; });
  (PV.addons || []).forEach((a) => { const on = (ids || []).includes(a.id); updates[a.variant] = on ? 1 : 0; if (on) items.push(a.variant + ":1"); });
  try {
    await queue;
    await post("/cart/update.js", { updates });
    window.location.href = "/checkout";
  } catch (e) {
    window.location.href = "/cart/" + items.join(",");
  }
};

// Checkout pill.
PV.money = (c) => "$" + (c / 100).toFixed(2);
const siteBagHasItems = () => { try { const b = JSON.parse(localStorage.getItem("outline-cart-v1")); return !!(b && b.quantity); } catch (e) { return false; } };
PV.cartPill = () => {
  let el = null, last = "";
  const draw = (cart) => {
    const n = (cart && cart.item_count) || 0;
    const show = n > 0 && document.body.dataset.template !== "cart" && !(document.getElementById("root") && siteBagHasItems());
    const key = show + ":" + n + ":" + (cart && cart.total_price);
    if (key === last) return; last = key;
    if (!show) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement("a");
      el.className = "pv-cartpill"; el.href = "/checkout";
      document.body.appendChild(el);
    }
    el.hidden = false;
    el.setAttribute("aria-label", n + (n === 1 ? " item" : " items") + " in your cart, " + PV.money(cart.total_price) + ". Go to checkout");
    el.innerHTML = '<span class="pv-cartpill-n">' + n + "</span><span>" + (n === 1 ? "item" : "items") + " in your cart · " + PV.money(cart.total_price) + "</span><b>Checkout</b>";
  };
  const poll = async () => {
    if (document.visibilityState !== "visible") return;
    try { draw(await getCart()); } catch (e) {}
  };
  PV.refreshPill = poll;
  poll(); setInterval(poll, 4000);
  document.addEventListener("visibilitychange", poll);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", PV.cartPill); else PV.cartPill();

// Swipe through the product photos with a finger on phones and tablets.
(() => {
  const st = document.createElement("style");
  st.textContent = ".gallery-main{touch-action:pan-y}" +
    "@keyframes pvInR{from{transform:translateX(36px);opacity:.35}to{transform:none;opacity:1}}" +
    "@keyframes pvInL{from{transform:translateX(-36px);opacity:.35}to{transform:none;opacity:1}}" +
    ".gallery-main.pv-swipe-next .campaign-photo{animation:pvInR .28s ease-out}" +
    ".gallery-main.pv-swipe-prev .campaign-photo{animation:pvInL .28s ease-out}";
  document.head.appendChild(st);
  let x0 = null, y0 = 0;
  document.addEventListener("touchstart", (e) => {
    const g = e.target.closest && e.target.closest(".gallery-main");
    if (!g || e.touches.length !== 1 || e.target.closest("button")) { x0 = null; return; }
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener("touchend", (e) => {
    if (x0 === null) return;
    const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
    x0 = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return; // ignore taps and vertical scrolls
    const g = document.querySelector(".gallery-main");
    const btns = g && g.querySelectorAll(".gallery-controls button");
    if (!btns || btns.length < 2) return;
    (dx < 0 ? btns[btns.length - 1] : btns[0]).click();
    const cls = dx < 0 ? "pv-swipe-next" : "pv-swipe-prev";
    requestAnimationFrame(() => {
      const g2 = document.querySelector(".gallery-main");
      if (!g2) return;
      g2.classList.remove("pv-swipe-next", "pv-swipe-prev"); void g2.offsetWidth; g2.classList.add(cls);
      setTimeout(() => g2.classList.remove(cls), 320);
    });
  }, { passive: true });
})();
